import React, { useEffect, useState, useRef} from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {set_category_list, set_page_refresh} from "../../redux/action"

const AddSubcategory = () => {
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
    const dispatch = useDispatch();
    const [selVal, setSelVal] = useState(null)
    const closeRef = useRef(null);
    const [subCategory, setSubCategory] = useState({})
    const categories = useSelector((state) => [{label: t?.[l]?.["choose"] || "Choose", value: "choose"}].concat(state.category_list?.map((itm) => { return {label: itm.name, value: itm._id}})));
  
    const data = useSelector((state) => state.subcategory_edit);

    
    useEffect(() => {
        console.log("data", data, categories)
        if(!Object.keys(data || {}).length) {
            setSubCategory({name: "", description: "", categoryId: "", categoryName: ""})
            setSelVal(null)
        } else {
            setSubCategory(data)
            setSelVal(categories.filter((itm) => itm.value === data.categoryId)[0])
        }
        
    }, [data])

    const submit= async (event) => {
        event.preventDefault()
        event.stopPropagation()
        const form = event.currentTarget;
        console.log()
        try {
        if(form?.checkValidity()) {

            let res = await axios.post('addsubcategory/', subCategory)
            console.log(res)
            if(res.status == 200) {
                closeRef.current?.click()
                setSelVal(null)
                document.querySelector(".modal-backdrop").classList.toggle("show")
                dispatch(set_page_refresh("subcategories"))
            }
        }
        } catch(e) {
        console.log(e)
        return true;
        }
        

        return true;
    }
    useEffect(() => {
        async function fetchData() {
            
          let result = await axios.get('getusercategories/');
          dispatch(set_category_list(result.data))
        }
        fetchData()
      }, [])

      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSubCategory(prevState => ({
          ...prevState,
          [name]: value
        }));
      };
    return (
        <div>
            {/* Add Category */}
            <div className="modal fade" id="add-category">
                <div className="modal-dialog modal-dialog-centered custom-modal-two">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>{Object.keys(data || {}).length ? t?.[l]?.["edit_subcategory"] || "Edit Subcategory" : t?.[l]?.["create_subcategory"] || "Create Subcategory"}</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body custom-modal-body">
                                    <form onSubmit={submit}>
                                        <div className="mb-3">
                                            <label className="form-label">{t?.[l]?.["parent_category"] || "Parent Category"} </label>
                                            <Select
                                                className="select"
                                                options={categories}
                                                placeholder={t?.[l]?.["choose"] || "Choose"}
                                                required
                                                value = {selVal}
                                                onChange={(v) => {
                                                    setSelVal(v)
                                                    handleInputChange({target: {name: "categoryId", value: v.value}})
                                                    handleInputChange({target: {name: "categoryName", value: v.label}})
                                                }}
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">{t?.[l]?.["sub_category_name"] || "Sub Category Name"}</label>
                                            <input type="text" className="form-control" value={subCategory?.name || ""} required name="name" onChange={handleInputChange}/>
                                        </div>
                                        <div className="mb-3 input-blocks">
                                            <label className="form-label">{t?.[l]?.["description"] || "Description"}</label>
                                            <textarea className="form-control" value={subCategory?.description || ""} name="description" onChange={handleInputChange}/>
                                        </div>
                                        <div className="mb-0 hidden">
                                            <div className="status-toggle modal-status d-flex justify-content-between align-items-center">
                                                <span className="status-label">Status</span>
                                                <input
                                                    type="checkbox"
                                                    id="user2"
                                                    className="check"
                                                    defaultChecked="true"
                                                />
                                                <label htmlFor="user2" className="checktoggle" />
                                            </div>
                                        </div>
                                        <div className="modal-footer-btn">
                                            <button
                                                type="button"
                                                className="btn btn-cancel me-2"
                                                data-bs-dismiss="modal"
                                                ref={closeRef}
                                            >
                                                {t?.[l]?.["cancel"] || "Cancel"}
                                            </button>
                                            <button type='submit' className="btn btn-submit">
                                            {Object.keys(data || {}).length ? t?.[l]?.["edit_subcategory"] || "Edit Subcategory" : t?.[l]?.["create_subcategory"] || "Create Subcategory"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Category */}
        </div>
    )
}

export default AddSubcategory
